import {CompleteStore} from "../../../../../reducers/reducerTypes";
import {SessionStoreType} from "../../storeTypes";

export const getSession = (state: CompleteStore): SessionStoreType =>
{
	return (state.session);
}
